const text = "_35st1jmmcfb";

export { text };
import "./input.readonly.style.linaria.module.css";
//# sourceMappingURL=input.readonly.style.js.map
